const isPlainObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

// Fusionne base et overrides récursivement : une clé absente d'overrides
// retombe sur base, plutôt que de disparaître (cas des traductions DB qui
// ne couvrent pas encore toutes les clés du fallback statique).
export const deepMerge = (base, overrides) => {
  const result = { ...base };
  Object.entries(overrides || {}).forEach(([key, value]) => {
    result[key] = isPlainObject(value) && isPlainObject(base?.[key]) ? deepMerge(base[key], value) : value;
  });
  return result;
};
